import { FlameIcon } from '@/common/components/icons'
import { DataBlock, GenericDialog } from '@/common'
import { UnitLabel } from '@/shared/config/config'
import { HeatEmissionRaw } from '@/api/EmissionReportModel'
import ReportSectionCard from '../ReportSectionCard'
import useDialog from '@/common/hooks/useDialog'
import HeatEmissionsReportingGeneric from './HeatEmissionsReportingGeneric'
import useI18n from '@/shared/hooks/useI18n'

export default function HeatSection({
  isComplete,
  heatEmissionRaw,
  isViewMode,
  reportId,
  emissions,
  processId
}: {
  isComplete: boolean
  heatEmissionRaw: HeatEmissionRaw | null
  isViewMode: boolean
  reportId: string
  emissions: number
  processId: string
}) {
  const { t, numberFormatter3Decimals } = useI18n()
  const { open, openDialog, closeDialog } = useDialog()
  const heatImportedEmission = numberFormatter3Decimals(heatEmissionRaw?.heatImportedEmission || 0)
  const heatExportedEmission = numberFormatter3Decimals(heatEmissionRaw?.heatExportedEmission || 0)

  const completionPercentage = isComplete ? 100 : 0
  return (
    <>
      <ReportSectionCard
        icon={<FlameIcon className="size-4" />}
        title={t('report:heat.title')}
        emissions={emissions}
        reportButtonText={t('report:heat.reportButtonText')}
        onEdit={openDialog}
        isComplete={isComplete}
        isViewMode={isViewMode}
        completionPercentage={completionPercentage}
      >
        <div className="grid grid-cols-2 gap-4">
          <DataBlock
            label={t('report:heat.generic.import.fields.heatImportedEmission.label')}
            data={`${heatImportedEmission} ${UnitLabel.tCO2e}`}
          />
          <DataBlock
            label={t('report:heat.generic.export.fields.heatExportedEmission.label')}
            data={`${heatExportedEmission} ${UnitLabel.tCO2e}`}
          />
        </div>
      </ReportSectionCard>
      <GenericDialog title={t('report:heat.title')} isOpen={open} close={closeDialog} size="4xl">
        <HeatEmissionsReportingGeneric
          close={closeDialog}
          initialValues={heatEmissionRaw || null}
          reportId={reportId}
          processId={processId}
        />
      </GenericDialog>
    </>
  )
}
